import Vue from 'vue';
import dateFormatter from '../mixins/dateFormatter';
import ActionModal from '../components/ActionModal';
import RescheduleCampaignModal from '../components/campaign/manage/modal/RescheduleCampaignModal';
import SetCampaignExpirationModal from '../components/campaign/manage/modal/SetCampaignExpirationModal';
import ManageCampaignRecentContactActivitiesTable
  from '../components/tables/ManageCampaignRecentContactActivitiesTable';
import ManageCampaignRecentCampaignActivitiesTable
  from '../components/tables/ManageCampaignRecentCampaignActivitiesTable';
import {getCampaignActivities} from '../utility/api/campaign/getCampaignActivities';
import {getCampaignFormSubmissions} from '../utility/api/campaign/getCampaignFormSubmissions';
import swal from 'sweetalert2';
import {listenToPusherNotifications} from '../utility/notifications/listenToPusherNotifications';

Vue.component('manage-campaigns-view', {
  mixins: [dateFormatter],
  components: {
    ManageCampaignRecentContactActivitiesTable,
    ManageCampaignRecentCampaignActivitiesTable,
    ActionModal,
    RescheduleCampaignModal,
    SetCampaignExpirationModal,
  },
  data() {
    return {
      campaign: JSON.parse(this.vueCampaign),
      campaignContactActivityMeta: JSON.parse(this.vueCampaignContactActivityMeta),
      downloadingActivities: false,
      downloadingFormSubmissions: false,
      submissionsCount: this.vueFormSubmissionsCount,
    };
  },
  methods: {
    dateNow: function () {
      return moment().format('YYYY-MM-DD h:mm:ss');
    },
    campaign_token(id) {
      return btoa('campaign_id=' + id);
    },
    async onDownloadFormSubmissionsClick() {
      if (this.downloadingFormSubmissions) {
        return;
      }

      swal.fire({
        title: 'Success!',
        text: 'Your campaign form submissions are currently being exported. You can continue to use the site and we will notify you once the export is complete.',
        type: 'success',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-primary'
      });

      this.downloadingFormSubmissions = true;
      await getCampaignFormSubmissions(this.campaign.id)
          .finally(() => this.downloadingFormSubmissions = false);
    },
    async onDownloadActivitiesClick() {
      if (this.downloadingActivities) {
        return;
      }

      swal.fire({
        title: 'Success!',
        text: 'Your campaign activities are currently being exported. You can continue to use the site and we will notify you once the export is complete.',
        type: 'success',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-primary'
      });

      this.downloadingActivities = true;
      await getCampaignActivities(this.campaign.id);
    },
  },
  props: ['vueCampaign', 'vueCampaignContactActivityMeta', 'vueFormSubmissionsCount', 'timezone'],
  mounted() {
    listenToPusherNotifications((notification) => {
      if (notification.type === 'campaign-activities-export-finished' || notification.type === 'campaign-form-submissions-export-finished') {
        this.downloadingActivities = false;
      }
    });
  },
});
